String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.slice(1);
}
var store_code = Cookies.get("_geo_store_code");
var currency_symbol = currency_symbols[store_code];
var sl_url = secretlab_url[store_code];
$(function () {
	function get_savings_dollar (price, msrp) {
        return parseInt(msrp - price);
    }
    function get_savings_percent (price, msrp) {
        return parseInt(((msrp - price) / msrp) * 100);
    }
    var store_code = Cookies.get("_geo_store_code");
    function build_pre_order_bar(round, estimated_date, percentage) {
        if (null === estimated_date || '' === estimated_date || undefined === estimated_date) {
            return '';
        } else {
            percentage = parseInt(percentage);
            var percent_word = percentage + '%',
                cls = 'bg-success progress-bar-striped progress-bar-animated';
            if (100 == percentage) {
                percent_word = 'CLOSED';
                cls = 'bg-danger';
            } else if (0 === percentage) {
                percentage = 100;
                percent_word = '';
                cls = 'bg-secondary';
            }
            var html = '<p class="pre-order-text">Pre-order wave ' + round + ' - Estimated shipping date: ' + estimated_date + '</p>';
            html += '<div class="progress"><div class="progress-bar w-' + percentage + ' ' + cls + '" style="width:' + percentage + '%" role="progressbar" aria-valuenow="' + percentage + '" aria-valuemin="0" aria-valuemax="100">' + percent_word + '</div></div>';
            return html;
        }
    }
    function variant_selection (id) {
        $('#selected_variant_id').val(id);
        if ('US' === store_code) {
            $('#product_add_on_selectors').removeClass('d-none');
            $('#product_cta_bar_prices_sl').hide(); // HIDE NON-US
            $('#variant_id_1_us, #variant_id_2_us').val(id);
            var has_addon = Cookies.get("_add_neue_headrest");
            if ('Y' == has_addon) {
                var us_price = variants[id].us_price+addon_headrest.us_price;
                var us_msrp = variants[id].us_msrp+addon_headrest.us_msrp;
            } else {
                var us_price = variants[id].us_price;
                var us_msrp = variants[id].us_msrp;
            }
            $('.stock-indicator-variant, .preorder-variant').hide();
            $('#stock_indicator_'+variants[id].handle+', #preorder_'+variants[id].handle).show();
            $('#price_us_1, #product_cta_bar_price').html(currency_symbol+us_price);
            if ( us_price < us_msrp ) {
                $('#msrp_us_content, #product_cta_bar_msrp').show();
                $('#msrp_us_1, #product_cta_bar_msrp').html(currency_symbol+us_msrp);
            } else {
                $('#msrp_us_content, #product_cta_bar_msrp').hide();
            }

            let savings_value = get_savings_dollar(us_price, us_msrp);
            if ( savings_value === 0 ) {
                $('#savings_value').hide();
            } else {
                $('#savings_value').show();
                $('#savings_us_1').html(currency_symbol+get_savings_dollar(us_price, us_msrp));
                $('#percentage_us_1').html(get_savings_percent(us_price, us_msrp));
            }
        } else {
            var variant = variants[id].handle;
            $('.add-to-cart-btn, .the-price-table, .product-cta-bar-price, .product-cta-bar-msrp').addClass('d-none');
            $('#add_to_cart_sl_1_'+variant+', #add_to_cart_sl_2_'+variant+', #price_table_'+variant+', #product_cta_bar_price_'+variant+', #product_cta_bar_msrp_'+variant).removeClass('d-none');
        }
        // TITLE
        $('#product_cta_bar_variant').html(variants[id].title);
        // SELECTOR
        $('.product-selector-option').removeClass('active');
        $('#product_selector_'+id).addClass('active');
        // TURNTABLE
        $('#product_still_image_tag').attr('src', turntable_img[id][0]);
        $('#product_turntable_ul').html('');
        $.each(turntable_img[id], function (i, img) {
            $('#product_turntable_ul').append('<li data-img-src="'+img+'"></li>');
        });
        $('#product_turntable_wrapper').turntable();
        // BUTTON
        if ('available' === $('#product_selector_'+id).attr('data-status')) {
            $('#add_to_cart_button_1_us, #add_to_cart_button_2_us').removeClass('btn-warning btn-secondary').addClass('btn-primary').val('Add To Cart').prop('disabled', false);
        } else if ('pre-order' === $('#product_selector_'+id).attr('data-status')) {
            $('#add_to_cart_button_1_us, #add_to_cart_button_2_us').removeClass('btn-primary btn-secondary').addClass('btn-warning').val('Pre-Order Now').prop('disabled', false);
        } else if ('out-of-stock' === $('#product_selector_'+id).attr('data-status')) {
            $('#add_to_cart_button_1_us, #add_to_cart_button_2_us').removeClass('btn-primary btn-warning').addClass('btn-secondary').val('Sold Out').prop('disabled', true);
        } else if ('not-available' === $('#product_selector_'+id).attr('data-status')) {
            $('#add_to_cart_button_1_us, #add_to_cart_button_2_us').removeClass('btn-primary btn-warning').addClass('btn-secondary').val('Not Available').prop('disabled', true);
        }
        // HASH
        window.location.hash = variants[id].handle;
        // REVIEWS
        var go_reviews = Cookies.get('_go_reviews');
        if ('go' === go_reviews) {
            setTimeout(function() {
              $('.product-features-option').removeClass('active');
              $('#product_features_reviews').addClass('active');

              $('.product-section-content').slideUp();
              $('#'+$('#product_features_reviews').attr('data-target')).slideDown();
              if ( $(window).width() < mobile_breakpoint ) {
                $('html, body').animate({scrollTop: $('#product_features_ghost').offset().top-133+35}, 500);
              } else {
                $('html, body').animate({scrollTop: $('#product_features_ghost').offset().top-70+35}, 500);
              }

              Cookies.remove('_go_reviews');
            }, 50);
        }
        // FOR US PRICE, TO BE UPDATE - ALF. FYI, NAT
        fbq('track', 'ViewProductNeue', {
            content_type    : 'product',
            content_ids     : variants[id],
            content_name    : variants[id].title,
            currency        : currency_symbol,
            value           : variants[id].us_price });
        fbq('track', 'ViewProductNeueHome' + store_code, {
            content_type    : 'product',
            content_ids     : variants[id],
            content_name    : variants[id].title,
            currency        : currency_symbol,
            value           : variants[id].us_price });
    }
    // SET UP VARIANTS' BUTTONS
    $.each(variants, function (i, v) {
        $('#product_selector_wrapper').append('<div class="col-12 col-sm-6 product-selector-wrapper"><div class="product-selector-option" id="product_selector_'+i+'" data-id="'+i+'" data-status="'+v.inventory_status+'"><div class="vertical-align"><div class="row">'+
                '<div class="col-auto"><img class="swatch" src="'+v.swatch+'" /></div>'+
                '<div class="col product-selector-title"><div class="vertical-align"><span id="preorder_badge_for_'+v.handle+'"></span><b>'+v.title+'</b> '+v.badge+'</div></div>'+
                '<div class="col-12"><p>'+v.desc_line+'</p></div>'+
                '<div class="col-12">'+
                    '<span class="product-selector-price" id="product_selector_button_price_'+v.handle+'">$'+v.us_price+'</span> '+
                    // '<span class="product-selector-msrp" id="product_selector_button_msrp_'+v.handle+'">$'+v.us_msrp+'</span>'+
                '</div>'+
            '</div></div></div></div>');
        if ('US' === store_code) {
            var status_class = 'text-success',
                status_wording = 'In Stock';
            if ('out-of-stock' === v.inventory_status) {
                status_class = 'text-muted';
                status_wording = 'Out of Stock';
            } else if ('pre-order' === v.inventory_status) {
                status_class = 'text-warning';
                status_wording = 'Pre-order';
                $('#preorder_badge_for_'+v.handle).html('<span class="badge badge-warning">PRE-ORDER</span>');
            } else if ('not-available' === v.inventory_status) {
                status_class = 'text-dark';
                status_wording = 'Not Available';
            }
            $('#stock_indicator_area').append('<div class="stock-indicator-variant font-weight-bold '+status_class+'" id="stock_indicator_'+v.handle+'" data-quantity="'+v.quantity+'"><i class="fas fa-circle"></i> '+status_wording+'</div>');
        }
    });
    // AUTO SELECTED ID
    var auto_select_id = first_variant_id;
    var hash = (window.location.hash).replace('#', '');
    if (hash.indexOf('review') !== -1 || window.location.href.indexOf("stamped") > -1) {
        Cookies.set('_go_reviews', 'go');
    } else {
        $.each(variants, function (i, v) {
            if (hash === v.handle) {
                auto_select_id = i;
            }
        });
    }
    // IF NOT US
    var amtDiscountCode = "$50";
    if ( store_code == 'EU' ) {
		amtDiscountCode = '€50';
    } else if ( store_code == 'UK' ) {
		amtDiscountCode = '£40';
    } else if ( store_code == 'AU' ) {
		amtDiscountCode = 'A$70';
    } else if ( store_code == 'SG' ) {
		amtDiscountCode = 'S$70';
    }

    if ('US' !== store_code) {
        // HIDE US
        $('#price_table_us, #add_to_cart_us, #add_to_cart_us_2, #product_cta_bar_prices_us').hide();
        // ADD TO CART
        var rfsn_raw = Cookies.get('_rfsn_url_part'), rfsn = '';
        if ('' !== rfsn_raw && undefined !== rfsn_raw) {
            rfsn = '?'+rfsn_raw;
        }
        $.each(variants, function (i, v) {
            $('#add_to_cart_sl').append('<a target="_blank" href="'+sl_url+v.sl_link_col+rfsn+v.sl_link_hash+'" data-reseller="secretlab" class="d-none btn btn-primary btn-lg btn-block add-to-cart-btn reseller-link" id="add_to_cart_sl_1_'+v.handle+'"><i class="fas fa-shopping-cart"></i><span class="product-cta-text-wrapper"><span>Checkout at our</span>Official Distributor Secretlab</span></a>');
            $('#add_to_cart_sl_2').append('<a target="_blank" href="'+sl_url+v.sl_link_col+rfsn+v.sl_link_hash+'" data-reseller="secretlab" class="d-none btn btn-primary btn-lg btn-block add-to-cart-btn add-to-cart-bar-btn reseller-link" id="add_to_cart_sl_2_'+v.handle+'"><i class="fas fa-shopping-cart"></i><span class="product-cta-text-wrapper"><span>Checkout at our</span>Official Distributor Secretlab</span></a>');
        });
        $.each(variants, function (i, v) {
            var current_price = '', current_msrp = '', currency_price = '', currency_msrp = '';
            if ( store_code == 'UK' ) {
                current_price = parseInt(v.uk_price);
                current_msrp = parseInt(v.uk_msrp);
            } else if ( store_code == 'EU' ) {
                current_price = parseInt(v.eu_price);
                current_msrp = parseInt(v.eu_msrp);
            } else if ( store_code == 'AU' ) {
                current_price = parseInt(v.au_price);
                current_msrp = parseInt(v.au_msrp);
            } else if ( store_code == 'SG' ) {
                current_price = parseInt(v.sg_price);
                current_msrp = parseInt(v.sg_msrp);
            }
            currency_price = currency_symbol+current_price;
            currency_msrp = currency_symbol+current_msrp;

            // PRICE TABLE
            $('#price_tables_sl').append('<table class="the-price-table" id="price_table_'+v.handle+'" class="d-none">'+
                ( current_price < current_msrp ? '<tr><td>MSRP:</td><td class="price-msrp">'+currency_msrp+'</td></tr>' : '' )+
                '<tr><td>You Save:</td><td class="price-table-savings">'+currency_symbol+get_savings_dollar(current_price, current_msrp)+' ('+get_savings_percent(current_price, current_msrp)+'% off)</td></tr>'+
                '<tr><td>Direct Price:</td><td class="price-direct">'+currency_price+'</td></tr></table>');
            // PRICE IN BUTTON
            $('#product_selector_button_price_'+v.handle).html(currency_price);
            if ( store_code === 'US' || current_price >= current_msrp ) {
                $('#product_selector_button_msrp_'+v.handle).hide();
            } else {
                $('#product_selector_button_msrp_'+v.handle).html(currency_msrp);
            }
            // PRICE IN CTA BAR
            $('#product_cta_bar_prices_sl').append('<div class="vertical-align">'+
                    '<span id="product_cta_bar_price_'+v+'" class="product-cta-bar-price d-none">'+currency_price+'</span><br>'+
                    // '<span id="product_cta_bar_msrp_'+v+'" class="product-cta-bar-msrp d-none">'+currency_msrp+'</span>'+
                '</div>');
        });
        variant_selection(auto_select_id);
    } else {
        // AFFIRM
        $('.affirm-as-low-as').show();
        // STOCK INDICATOR + PREORDER
        $.get('https://beans.secretlab.co/index.php/api/2019-08/en/product_page/' + store_code + '/' + collection_handle, function (data) {
            $.each(data.stock_info.stock_control, function (i, v) {
                var threshold = parseInt(v.low_stock_threshold),
                    quantity = parseInt($('#stock_indicator_'+v.variant).attr('data-quantity'));
                if (0 < quantity && quantity <= threshold) {
                    $('#stock_indicator_'+v.variant).removeClass('text-success').addClass('text-danger').html('<i class="fas fa-circle"></i> Low Stocks Remaining');
                }
            });
            $.each(data.stock_info.preorder, function (i, v) {
                if ('' === v.est_date_string || undefined === v.est_date_string || null === v.est_date_string) {
                    var wave_html = build_pre_order_bar('1', v.round_1_date, v.round_1_percent);
                    wave_html += build_pre_order_bar('2', v.round_2_date, v.round_2_percent);
                    wave_html += build_pre_order_bar('3', v.round_3_date, v.round_3_percent);
                    if ('' !== wave_html) {
                        $('#preorder_area').append('<div class="preorder-variant" id="preorder_' + v.variant + '"><p>'+
                        'We\'re trying our best to stock units as fast as we can. Orders will be shipped in waves according to a first-come, first-served basis.'+
                        '</p>' + wave_html + '</div>');
                    }
                } else {
                    $('#stock_indicator_'+v.variant).append(': '+v.est_date_string);
                }
            });
            // SELECT 1ST VARIANT AFTER THE LOOPS
            variant_selection(auto_select_id);
        }, 'json');
    }
    // VARIANT SELECTION
    $('body').on('click', '.product-selector-option', function () {
        var id = $(this).attr('data-id');
        variant_selection(id);
        if ($(document).width() < mobile_breakpoint) {
            $('html, body').animate({scrollTop: $('#product_still_image').offset().top}, 500);
        }
    });
    // ADD ALTERNATIVE RESELLER
    if (country_resellers[store_code] == undefined) {
        $('.alternative-reseller').hide();
    } else {
        $.each(country_resellers[store_code], function (i, v) {
            var url = v.link;
            if ('secretlab' === v.code) {
                var rfsn = Cookies.get('_rfsn_url_part');
                if ('' !== rfsn && undefined !== rfsn) {
                    url = url+'?'+rfsn;
                }
            }
            $('#product_main_resellers_area').append('<div class="col-auto text-center">'+
                '<a class="reseller-link" href="'+url+'" title="'+v.name+'" data-reseller="'+v.code+'" target="_blank"><img class="img-fluid" src="'+reseller_logos[v.code]+'" />');
        });
    }
    // RETURN DAYS
    if ('UK' === store_code || 'EU' === store_code) {
        $('#return_policy_days').html('14');
    }
    $('#product_cta_main_reseller').click(function (e) {
        e.preventDefault();
        $('#product_main_resellers_area').slideToggle();
    });
    $('body').on('click', '.reseller-link', function (e) {
        e.preventDefault();
        var event = 'ClickTo'+($(this).attr('data-reseller')).capitalize()+store_code;
        fbq('track', event);
        var win = window.open($(this).attr('href'), '_blank');
        win.focus();
    });
    // FAQ - SHIPPING
    $.get(`https://beans.secretlab.co/index.php/api/retrieve_faq/nx${(store_code === 'US' ? '' : `_${store_code}`)}/product`, function (data) {
        $.each(data.faq, function (category, sets) {
            $.each(sets, function (key, row) {
                $('#'+category+'_content').append('<div class="faq-question-wrapper" id="'+key+'_wrapper"><div class="row faq-question" data-id="'+key+'">'+
                                '<div class="col">'+row.the_question+'</div><div class="col-auto"><span><i class="fas fa-angle-right"></i></span></div>'+
                                '</div><div class="faq-answer" style="display:none">'+row.the_answer+'</div></div>');
            });
        });
        $('.replace_email').each(function () {
            $(this).html(store_email).attr('href', 'mailto:'+store_email);
        });
    }, 'json');

    // ACCORDION
    $('body').on('click', '.faq-question', function() {
        if ( $(this).hasClass('active') ) {
            $(this).parent().children('.faq-answer').stop().slideUp();
            $(this).removeClass('active');
            $(this).find('span').removeClass('rotate90');
        } else {
            $('.faq-answer').stop().slideUp();
            $('.faq-question').removeClass('active');
            $('.faq-question').find('span').removeClass('rotate90');
            $(this).parent().children('.faq-answer').stop().slideDown();
            $(this).addClass('active');
            $(this).find('span').addClass('rotate90');
        }
    });

	// ADD-ON
    Cookies.set("_add_neue_headrest", "N", { expires: 1, path: '/' });
    $('.product-add-on-selector').click(function () {
        var id = $('#selected_variant_id').val();
        var value = $(this).attr('data-value');
        $('.product-add-on-selector').removeClass('active');
        $(this).addClass('active');
        if ('1' === value) {
            Cookies.set("_add_neue_headrest", "Y", { expires: 1, path: '/' });
            $('#product_cta_bar_addon').html('+ NeueChair Headrest');
            var us_price = variants[id].us_price+addon_headrest.us_price;
            var us_msrp = variants[id].us_msrp+addon_headrest.us_msrp;
        } else {
            Cookies.set("_add_neue_headrest", "N", { expires: 1, path: '/' });
            $('#product_cta_bar_addon').html('');
            var us_price = variants[id].us_price;
            var us_msrp = variants[id].us_msrp;
        }
        $('#price_us_1, #product_cta_bar_price').html(currency_symbol+us_price);
        if ( us_price < us_msrp ) {
            $('#msrp_us_content, #product_cta_bar_msrp').show();
            $('#msrp_us_1, #product_cta_bar_msrp').html(currency_symbol+us_msrp);
        } else {
            $('#msrp_us_content, #product_cta_bar_msrp').hide();
        }

        let savings_value = get_savings_dollar(us_price, us_msrp);
        if ( savings_value === 0 ) {
            $('#savings_value').hide();
        } else {
            $('#savings_value').show();
            $('#savings_us_1').html(currency_symbol+get_savings_dollar(us_price, us_msrp));
            $('#percentage_us_1').html(get_savings_percent(us_price, us_msrp));
        }
    });
});